import React, { Component } from 'react';

import SidebarComponent from '../components/SidebarComponent';
import NavbarComponent from '../components/NavbarComponent';
import HeaderComponent from '../components/HeaderComponent';
import { validateSession } from '../utils/functions';
import { navigateTo } from '../utils/navigation';
import { createCollection } from '../utils/collectionsApi';

class AddLabelPage extends Component {

    constructor() {
        super();
        const cachedRole = Number(localStorage.getItem('role') || 0);
        this.state = {
            checked: false,
            role: cachedRole,
            name: '',
            formError: null,
            disabled: false,
        };
        this.mounted = false;
    }

    async componentDidMount() {
        this.mounted = true;
        // validateSession(true): crear una colección no tiene nada que ver con la caja. Sin el
        // flag, un manager con la caja cerrada entraba al listado, tocaba "+" y lo mandaba a
        // /caja sin decirle por qué — parecía que el botón estaba roto.
        const role = await validateSession(true);
        if (!this.mounted) return;
        this.setState({ checked: true, role });
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    onClickSave = () => {
        const name = this.state.name.trim();
        if (!name) {
            this.setState({ formError: 'El nombre es obligatorio.' });
            return;
        }

        this.setState({ disabled: true, formError: null });
        createCollection(name)
            .then((data) => {
                if (!this.mounted) return;
                // El POST devuelve { id, slug }: se puede encadenar directo a curar la colección
                // recién creada, que es lo único que tiene sentido hacer a continuación. Antes
                // devolvía sólo { error, message } y había que volver al listado y buscarla.
                const id = data && data.id;
                if (id) {
                    navigateTo(`/labelAssign?id=${id}`);
                } else {
                    // Backend viejo (sin id en la respuesta): al menos no dejarlo colgado.
                    navigateTo('/labels');
                }
            })
            .catch((error) => {
                if (!this.mounted) return;
                this.setState({ disabled: false, formError: error.message });
            });
    }

    render() {
        if (!this.state.checked) {
            return (<div></div>);
        }

        return (
            <div className="container-fluid">
                <div className="row">
                    <SidebarComponent itemSelected={15} role={this.state.role} />
                    <main className="main-content col-lg-10 col-md-9 col-sm-12 p-0 offset-lg-2 offset-md-3">
                        <NavbarComponent role={this.state.role} />
                        <div className="main-content-container container-fluid px-4 mb-4">
                            <HeaderComponent title="Etiquetas" subtitle="Nueva colección de la home" />
                            <div className="row">
                                <div className="col-lg-8">
                                    <div className="card card-small mb-4">
                                        <div className="card-header border-bottom">
                                            <h6 className="m-0">Nueva colección</h6>
                                        </div>
                                        <ul className="list-group list-group-flush">
                                            <li className="list-group-item p-3">
                                                <p style={{ color: '#818ea3' }}>
                                                    Una colección es una de las secciones curadas de la home: el carrusel de arriba
                                                    o uno de los recuadros de categoría. Se crea <strong>privada</strong>: elegís los
                                                    productos con calma y recién después decidís publicarla.
                                                </p>
                                                <div className="form-row">
                                                    <div className="form-group col-md-6">
                                                        <label htmlFor="name">Nombre</label>
                                                        <input
                                                            id="name"
                                                            type="text"
                                                            className={`form-control ${this.state.formError ? 'is-invalid' : ''}`}
                                                            placeholder="Por ejemplo: Novedades"
                                                            maxLength={45}
                                                            value={this.state.name}
                                                            onChange={(e) => this.setState({ name: e.target.value, formError: null })}
                                                        />
                                                        <small className="form-text text-muted">
                                                            Es el título que ve el cliente. El nombre corto que usa la tienda por dentro
                                                            se genera solo.
                                                        </small>
                                                    </div>
                                                </div>

                                                {this.state.formError ? (
                                                    <div className="alert alert-danger p-2" style={{ fontSize: '13px' }}>{this.state.formError}</div>
                                                ) : null}
                                            </li>
                                        </ul>
                                        <div className="card-footer border-top">
                                            <button
                                                type="button"
                                                className="btn btn-white mr-2"
                                                onClick={() => navigateTo('/labels')}
                                            >Cancelar</button>
                                            <button
                                                onClick={this.onClickSave}
                                                type="button"
                                                className="mb-0 btn btn-primary"
                                                style={{ float: 'right' }}
                                                disabled={this.state.disabled}
                                            >
                                                {this.state.disabled ? 'Creando…' : 'Crear y elegir productos'}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </main>
                </div>
            </div>
        );
    }
}

export default AddLabelPage;
